export default __webpack_public_path__ + "static/media/like.25a71bc6.svg";